export var CustomerRole;
(function (CustomerRole) {
    CustomerRole["ADMIN"] = "ADMIN";
    CustomerRole["PURCHASER"] = "PURCHASER";
})(CustomerRole || (CustomerRole = {}));
